(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nl-ship-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nl-ship-bar')) {
    customElements.define('nl-ship-bar', class extends HTMLElement {
      connectedCallback() {
        const date = new Date(this.dataset.dispatch + 'T12:00:00Z');
        const time = this.querySelector('time');
        time.dateTime = date.toISOString().slice(0,10);
        time.textContent = date.toLocaleDateString(this.dataset.locale.startsWith('ar') ? 'ar-EG' : 'en-GB', {weekday:'long', day:'numeric', month:'long', timeZone:'UTC'});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
